import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetNotificationsState from './notifications';

export default (state = initialState, action) => chooseReducer(state, action, updateDatasetNotificationsState);
